import { useHasPermission } from "../auth/useClaims";

// Standard fine-grained permission codes. Approve/Reject on an enquiry are
// NOT single declarative policies on the API - the real check combines
// these with Admin.SelfApproval and the external-quotation-path rule (see
// SalesService.ApproveEnquiryAsync/RejectEnquiryAsync). These booleans only
// decide whether to SHOW a control; the server remains the authority, same
// disclaimer as Petty Cash's self-pay ceiling.
export const useCanCreateEnquiry = () => useHasPermission("Sales.CreateEnquiry");
export const useCanViewSales = () => useHasPermission("Sales.View");
export const useCanViewAllSales = () => useHasPermission("Sales.ViewAll");
export const useCanApproveEnquiry = () => useHasPermission("Sales.ApproveEnquiry");
export const useCanApproveWithExternalQuotation = () => useHasPermission("Sales.ApproveWithExternalQuotation");
export const useCanUploadQuotation = () => useHasPermission("Sales.UploadQuotation");
export const useCanCreateConfirmedOrder = () => useHasPermission("Sales.CreateConfirmedOrder");
export const useCanCloseOrder = () => useHasPermission("Sales.CloseOrder");
export const useCanManageOperations = () => useHasPermission("Sales.ManageOperations");
// Order Detail's per-line deployment-progress update only - Deployment.View
// (Upcoming Deployments) is out of scope this pass, see project plan.
export const useCanEditDeployment = () => useHasPermission("Deployment.Edit");
export const useCanSelfApprove = () => useHasPermission("Admin.SelfApproval");
// Commission recording/reversal on a CLOSED order (2026-09-08). One
// permission gates both the worklist screen and the per-order card - paying
// a commission and un-paying it are the same job.
export const useCanManageCommission = () => useHasPermission("Sales.ManageCommission");

// Book an enquiry or confirmed order in ANOTHER employee's name (Batch148).
// Its own permission rather than folded into Sales.CreateEnquiry: everyone who
// sells raises their own enquiries, but the salesperson named on an order is
// who the COMMISSION is paid to, so attributing one to someone else moves real
// money and is not something every seller should be able to do.
export const useCanBookForOthers = () => useHasPermission("Sales.BookForOthers");

// Client Visit Report (Batch182). Recording a visit happens in the Flutter
// app (QR scanner + GPS gate), so Sales.LogClientVisit only matters here for
// reaching the report - somebody who records visits should be able to look
// them up. Sales.ViewAllClientVisits is what widens the report from "my own
// visits" to the whole branch; the server enforces that, these hooks only
// decide what to show.
export const useCanLogClientVisit = () => useHasPermission("Sales.LogClientVisit");
export const useCanViewClientVisits = () => useHasPermission("Sales.ViewClientVisits");
export const useCanViewAllClientVisits = () => useHasPermission("Sales.ViewAllClientVisits");
